<template>
    <div class="leftnav">
        <el-row class="tac">
            <el-col :span="12">
                <el-menu
                    :default-active="$route.path"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    :unique-opened="true"
                    :router="true"
                    background-color="#2f4050"
                    text-color="#a7a6a1"
                    active-text-color="#1890ff"
                    @close="handleClose">
                    <el-submenu v-for="item in routeList" :index='String(item.ID)' :key="item.Name">
                        <template slot="title">
                        <i class="el-icon-location"></i>
                        </template>
                        <template slot="title">{{item.Name}}</template>
                        <div
                            v-for="child in item.ChildrenList" 
                            :key="child.Path" 
                            :index="child.Path" 
                            @click="chooseItem(child)">
                            <!-- 不存在子级 -->
                            <el-menu-item v-if="child.ChildrenList.length==0" :key="child.Path" :index="child.Path">
                                {{child.Name}}
                            </el-menu-item>
                            <!-- 还存在子级 -->
                            <div v-if="child.ChildrenList.length!=0">
                                <el-submenu :index="child.Name">
                                    <template slot="title">{{child.Name}}</template>
                                    <el-menu-item
                                    v-for="childV2 in child.ChildrenList" 
                                    :key="childV2.Path" 
                                    :index="childV2.Path" 
                                    @click="chooseItem(childV2)">
                                        {{childV2.Name}} 
                                    </el-menu-item>
                                </el-submenu>
                            </div>
                        </div>
                        
                    </el-submenu>
                </el-menu>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import {routeList} from '@/router/index.js'
import {AddMoudle} from '@/api/module'
import store from '@/store'
export default{
    name:'leftNav',
    data(){
        return{
            routeList:[],
        }
    },
    computed:{
        ...mapState({
            tagsList:(state)=>state.tag.tags
        })
    },
    methods:{
        handleOpen(){
        },
        handleClose(){
        },
        chooseItem(e){
            this.tagsList.push(e)
        }
        
    },
    created(){
        console.log(this.$store.state.login.user)

        AddMoudle().then(res=>{
            console.log(res)
            this.routeList = res.data
        })
        console.log(window.localStorage.getItem('token'))
        console.log(routeList)
        this.routeList = routeList
        console.log(this.routeList,this.$route.path)
    }
}
</script>
<style scoped>
*{
    box-sizing: border-box;
}
.leftnav{
    width: 15%;
    min-height: 93vh;
    overflow-y: auto;
}
/deep/ .tac.el-row{
    height: 100%;
}

/deep/ .el-col.el-col-12{
    height: 100%;
}
/deep/ .el-menu-vertical-demo.el-menu{
    height: 100%;
}

/deep/ .el-col-12{
    width: 100%;
}

/deep/ .el-submenu .el-menu-item{
    min-width: unset;
}
/* /deep/.el-col.el-col-12{
    height: 100%;
}
/deep/.el-menu-vertical-demo.el-menu{
    height: 100%;
} */
</style>